(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'vue', 'js-cookie'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('vue'), require('js-cookie'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.vue, global.jsCookie);
    global.env = mod.exports;
  }
})(this, function (exports, _vue, _jsCookie) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isDarkMode = exports.isWeiXQ = exports.isVivo = exports.isVivoApp = exports.isVivoBrowser = exports.isQuickapp = exports.isMinigamecenter = exports.isSdkplugin = exports.isAccount = exports.isVivoVideo = exports.isiTheme = exports.isiMusic = exports.isAppStore = exports.isSpace = exports.isGameCenter = exports.isCombineWallet = exports.isLoanApp = exports.isBasicWallet = exports.isWallet = exports.root = exports.isIOS = exports.isAndroid = exports.UA = exports.inBrowser = exports.isProd = undefined;

  var _vue2 = _interopRequireDefault(_vue);

  var _jsCookie2 = _interopRequireDefault(_jsCookie);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // Development environment
  var isProd = exports.isProd = process.env.NODE_ENV === 'production';

  // Browser environment sniffing
  var inBrowser = exports.inBrowser = !_vue2.default.prototype.$isServer || typeof window !== 'undefined';
  var UA = exports.UA = inBrowser && window.navigator.userAgent.toLowerCase();
  var isAndroid = exports.isAndroid = UA && UA.indexOf('android') > 0;
  var isIOS = exports.isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
  var root = exports.root = typeof window !== 'undefined' ? window : global;
  // vivo env
  var vvcPn = _jsCookie2.default.get('vvc_pn');
  // vivo钱包
  var isWallet = exports.isWallet = vvcPn === 'com.vivo.wallet';
  // vivo钱包卸载后的基础包
  var isBasicWallet = exports.isBasicWallet = vvcPn === 'com.vivo.pay';
  // 贷款独立app，丰融
  var isLoanApp = exports.isLoanApp = vvcPn === 'com.fengrongkeji.loan';
  // 联合判断
  var isCombineWallet = exports.isCombineWallet = isWallet || isBasicWallet || isLoanApp;
  // 是否是游戏中心
  var isGameCenter = exports.isGameCenter = vvcPn === 'com.vivo.game';
  // 是否是官网
  var isSpace = exports.isSpace = vvcPn === 'com.vivo.space';
  // 是否是应用商店
  var isAppStore = exports.isAppStore = vvcPn === 'com.bbk.appstore';
  // 是否是i音乐
  var isiMusic = exports.isiMusic = vvcPn === 'com.android.bbkmusic';
  // 是否是i主题
  var isiTheme = exports.isiTheme = vvcPn === 'com.bbk.theme';
  // 是否是vivo视频
  var isVivoVideo = exports.isVivoVideo = vvcPn === 'com.android.VideoPlayer';
  // 是否是vivo账户
  var isAccount = exports.isAccount = vvcPn === 'com.bbk.account';
  // 是否是游戏联运SDK
  var isSdkplugin = exports.isSdkplugin = vvcPn === 'com.vivo.sdkplugin';
  // 是否是小游戏中心
  var isMinigamecenter = exports.isMinigamecenter = vvcPn === 'com.vivo.minigamecenter';
  // 是否是快应用中心
  var isQuickapp = exports.isQuickapp = vvcPn === 'com.quickapp.center';
  // 是否是vivo浏览器
  var isVivoBrowser = exports.isVivoBrowser = /vivoBrowser/i.test(window.navigator.userAgent);
  // 是否是vivo 应用
  var isVivoApp = exports.isVivoApp = (document.cookie || '').indexOf('vvc_pn') > -1 || isVivoBrowser || isAppStore || isiMusic || isSpace || isGameCenter || isiTheme || isVivoVideo || isAccount || isSdkplugin || isWallet || isBasicWallet || isMinigamecenter;
  // 是否是vivo手机
  var isVivo = exports.isVivo = /vivo/i.test(window.navigator.userAgent) || (document.cookie || '').indexOf('vvc_pn') > -1 || isVivoBrowser || isAppStore || isiMusic || isSpace || isGameCenter || isiTheme || isVivoVideo || isAccount || isSdkplugin || isWallet || isBasicWallet || isMinigamecenter;
  // 判断是否是微信环境
  var isWeiXQ = exports.isWeiXQ = /(micromessenger|webbrowser)/.test(navigator.userAgent.toLocaleLowerCase());

  var isDarkMode = exports.isDarkMode = !(document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off') && window.matchMedia('(prefers-color-scheme: dark)').matches;
});